import type { UpdateRequestById } from "@nlc/shared-types";

import { useId } from "react";

import { useMbcRequestSettings } from "../hooks/useMbcRequestSettings";
import { SegmentedRadioGroup } from "./SegmentedRadioGroup";
import { SidebarCard } from "./SidebarCard";

type CreativeDirection = NonNullable<UpdateRequestById["creativeDirection"]>;

type CreativeDirectionCardProps = {
  requestId: null | number;
};

const OPTIONS: { label: string; value: CreativeDirection }[] = [
  { label: "Creative freedom", value: "Designer has creative freedom" },
  { label: "Follow brief", value: "Follow brief exactly" },
];

export function CreativeDirectionCard({
  requestId,
}: CreativeDirectionCardProps) {
  const questionId = useId();
  const { creativeDirection, isLoading, save } =
    useMbcRequestSettings(requestId);

  return (
    <SidebarCard className="px-6 py-5">
      <h2 className="text-base font-bold text-text-primary" id={questionId}>
        Creative direction
      </h2>
      <SegmentedRadioGroup
        isDisabled={isLoading}
        labelledBy={questionId}
        onChange={(value) =>
          save({ creativeDirection: value as CreativeDirection })
        }
        options={OPTIONS}
        value={creativeDirection}
      />
    </SidebarCard>
  );
}
